import './HomePage.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import MwsEnvironmentSelector from "../components/MwsEnvironmentSelector";

const HomePage = (): React.JSX.Element => {
    const navigate = useNavigate();

    const handleNavigate = (path: string) => {
        navigate(path);
    };

    return (
        <div className="home-page">
            <div className="home-page-header">
                <div className="header-title">
                    <span className="title-text">Nginx配置中心</span>
                    <MwsEnvironmentSelector prefix="nginx" enableDevHost={true}/>
                </div>
            </div>
            <div className="buttons">
                <Button
                    className="button"
                    type="primary"
                    size="large"
                    onClick={() => handleNavigate('/service/list')}
                >
                    服务器列表
                </Button>
                <Button
                    className="button"
                    type="primary"
                    size="large"
                    onClick={() => handleNavigate('/conf/list')}
                >
                    配置列表
                </Button>
                <Button
                    className="button"
                    type="primary"
                    size="large"
                    onClick={() => handleNavigate('/ssl/script')}
                >
                    SSL更新脚本
                </Button>
            </div>
        </div>
    );
};

export default HomePage;
